import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FlyNOutLogo } from './Navbar';
import { Twitter, Instagram, Facebook, Linkedin, ChevronDown } from 'lucide-react';

const FooterSection = ({ title, links }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      {/* Desktop: always visible */}
      <div className="hidden sm:block">
        <h4 className="text-white font-semibold mb-3 text-sm">{title}</h4>
        <ul className="space-y-1.5">
          {links.map(([label, href]) => (
            <li key={label}>
              <Link to={href} className="text-sm text-gray-400 hover:text-[#FF4500] transition-colors">{label}</Link>
            </li>
          ))}
        </ul>
      </div>
      {/* Mobile: collapsible */}
      <div className="sm:hidden border-b border-gray-800 last:border-0">
        <button
          onClick={() => setOpen(!open)}
          className="w-full flex items-center justify-between py-3 text-white font-medium text-sm"
        >
          {title}
          <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
        </button>
        {open && (
          <ul className="pb-3 space-y-2">
            {links.map(([label, href]) => (
              <li key={label}>
                <Link to={href} className="block text-sm text-gray-400 hover:text-[#FF4500] transition-colors py-0.5">{label}</Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default function Footer() {
  return (
    <footer className="bg-[#111827] text-gray-300 mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12">

        {/* Mobile: Brand row compact */}
        <div className="flex items-center justify-between mb-6 sm:hidden">
          <div className="flex items-center gap-2">
            <FlyNOutLogo />
          </div>
          <div className="flex gap-2">
            {[Twitter, Instagram, Facebook, Linkedin].map((Icon, i) => (
              <a key={i} href="#" className="p-1.5 rounded-lg bg-gray-800 hover:bg-[#FF4500] transition-colors">
                <Icon className="w-3.5 h-3.5" />
              </a>
            ))}
          </div>
        </div>

        {/* Desktop grid / Mobile links */}
        <div className="grid sm:grid-cols-4 gap-0 sm:gap-8">

          {/* Desktop brand column */}
          <div className="hidden sm:block">
            <div className="flex items-center gap-2 mb-4">
              <FlyNOutLogo />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              Where every flight becomes a community. Connect with fellow travelers worldwide.
            </p>
            <div className="flex gap-3">
              {[Twitter, Instagram, Facebook, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="p-2 rounded-lg bg-gray-800 hover:bg-[#FF4500] transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <FooterSection
            title="Community"
            links={[['How it Works', '/how-it-works'], ['Discover', '/discover'], ['Airlines', '/airlines'], ['Blog', '/blog'], ['Premium Club', '/premium'], ['Leaderboard', '/community']]}
          />
          <FooterSection
            title="Company"
            links={[['About Us', '/about'], ['Contact', '/contact'], ['Careers', '/about'], ['Press', '/about']]}
          />
          <FooterSection
            title="Legal"
            links={[['Privacy Policy', '/privacy'], ['Terms of Service', '/terms'], ['Safety & Trust', '/safety'], ['Cookie Policy', '/cookies']]}
          />
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-6 sm:mt-10 pt-4 sm:pt-6 flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4">
          <p className="text-xs text-gray-500 text-center sm:text-left">
            © {new Date().getFullYear()} Fly'N Out. All rights reserved.
          </p>
          <span className="flex items-center gap-1.5 text-xs text-gray-500">
            <span className="w-1.5 h-1.5 rounded-full bg-[#10B981]" />
            Community is live worldwide
          </span>
        </div>
      </div>
    </footer>
  );
}
